import { defineComponent } from "vue";
import { VueProp } from "../../core/vueHelpers";

const FooterToolbarClasses =
{
    toolbar: "calendarFooterToolbar",
    button: "footerToolbar__button",
};

export default /*#__PURE__*/ defineComponent(
    {
        name: "footerToolbar",
        props:
        {
            buttonText: VueProp(String),
            onButtonClick: VueProp<(() => void) | ((event: MouseEvent) => void)>(Function),
            onDoneClick: VueProp<(() => void) | ((event: MouseEvent) => void)>(Function)
        },
        setup(props)
        {
            return () => (
                <div class={FooterToolbarClasses.toolbar}>
                    <button class={FooterToolbarClasses.button} onClick={props.onButtonClick} onKeydown={handleKeydown}>
                        {props.buttonText}
                    </button>
                    <button class={FooterToolbarClasses.button} onClick={props.onDoneClick} onKeydown={handleKeydown}>
                        Done
                    </button>
                </div>
            );

            async function handleKeydown(event: KeyboardEvent)
            {
                const eventKeys = window.skyward.keys.getKeyNamesFromEvent(event);
                if (eventKeys.ENTER)
                {
                    event.preventDefault();
                    const element = document.activeElement as HTMLElement;
                    element.click();
                }
            }
        }
    }
);